import React, { FC } from "react";
import { Text, View } from "react-native-web";
import { ReactComponent as Hotel } from "../../../assets/icons/hotel.svg";
import { ReactComponent as Restaurant } from "../../../assets/icons/restaurant.svg";
import styles from "./HeaderMenu.module.scss";
import { localizeMenuName } from "../../../utils/localization/apply";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { inlineStyles } from "./headerMenuInlineStyles";
import { useHeaderMenu } from "./useHeaderMenu";
import { HeaderMenuMobileHero } from "./HeaderMenuMobileHero";
import { HeaderMenuDesktopHero } from "./HeaderMenuDesktopHero";
import { HeaderMenuCategories } from "./HeaderMenuCategories";

interface HeaderMenuProps {
  handleFilter?: (title: string) => void;
}

export const HeaderMenu: FC<HeaderMenuProps> = ({ handleFilter }) => {
  const {
    menu,
    locale,
    isDesktop,
    locales,
    showLanguageSwitcher,
    changeLocale,
    hasFullHeader,
    videoUrl,
    status,
    openCloseTime,
    locationOpen,
    collapsedTime,
    setCollapsedTime,
    isOpen,
    toggleOpen,
    openDays,
    weekDaysMondayFirst,
    todayKey,
    formatTime,
    partners,
    activePartners,
    items,
    handleItemPress,
    handleLinkClick,
    handlePhoneClick,
    handleMapClick,
  } = useHeaderMenu();

  if (!menu) return null;

  const switcher = showLanguageSwitcher ? (
    <LanguageSwitcher
      locale={locale}
      locales={locales}
      onChange={changeLocale}
    />
  ) : null;

  const renderHero = () => {
    if (!hasFullHeader) {
      return (
        <View style={[inlineStyles.headerMenu]}>
          {menu?.establishmentType === "restaurant" ? (
            <Restaurant width={20} height={20} />
          ) : (
            <Hotel width={20} height={20} />
          )}
          <Text style={inlineStyles.headerMenuTitle}>
            {localizeMenuName(menu, locale)}
          </Text>
          {switcher}
        </View>
      );
    }

    if (isDesktop) {
      return (
        <HeaderMenuDesktopHero
          menu={menu}
          locale={locale}
          videoUrl={videoUrl}
          status={status}
          openCloseTime={openCloseTime}
          locationOpen={locationOpen}
          weekDaysMondayFirst={weekDaysMondayFirst}
          todayKey={todayKey}
          formatTime={formatTime}
          activePartners={activePartners}
          isOpen={isOpen}
          toggleOpen={toggleOpen}
          switcher={switcher}
          handleLinkClick={handleLinkClick}
          handlePhoneClick={handlePhoneClick}
          handleMapClick={handleMapClick}
        />
      );
    }

    return (
      <HeaderMenuMobileHero
        menu={menu}
        locale={locale}
        partners={partners}
        openDays={openDays}
        formatTime={formatTime}
        status={status}
        openCloseTime={openCloseTime}
        locationOpen={locationOpen}
        collapsedTime={collapsedTime}
        setCollapsedTime={setCollapsedTime}
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        switcher={switcher}
        handleLinkClick={handleLinkClick}
        handlePhoneClick={handlePhoneClick}
        handleMapClick={handleMapClick}
      />
    );
  };

  return (
    <div className={styles.container}>
      <View
        style={[inlineStyles.container, isDesktop ? { marginLeft: 0 } : null]}
      >
        {renderHero()}
        <HeaderMenuCategories
          items={items}
          isDesktop={isDesktop}
          onPress={handleItemPress}
        />
      </View>
    </div>
  );
};
